// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1zsXX","signatureBlock":"Footer_signatureBlock__2UXIN","signature":"Footer_signature__2FoGa"};